var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 17,
    viewBox: "0 0 67 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.960938,
    y: 0.489258,
    width: 65.1182,
    height: 16.2796,
    rx: 8.13978,
    fill: "#3E3E0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle2);
export default __webpack_public_path__ + "static/media/toggle2.edf10965992582525eeb9f809c461c14.svg";
export { ForwardRef as ReactComponent };